// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-uYObwx7J","statusTitle":"dp-WIa8cJaY","successTip":"dp-1cIbuKZY","btn":"dp-ZxKIrtGr"};